/*
  Square podcast artwork on podcast cards (sm-article-grid, "Square podcast
  artwork").

  Each card that wants artwork carries data-podcast-art with its article's
  publish time as a Unix timestamp, the same key the episode player uses. The
  artwork comes from assets/sm-podcast-episodes.json first. Episodes newer than
  that file are looked up in the shows' RSS feeds, which Buzzsprout serves
  with open CORS; the feed is only fetched when a card is missing from the
  file, and what it yields is kept in sessionStorage so browsing between
  episodes does not fetch it again.

  The article image rendered by Liquid stays in place until artwork is found,
  so a card is never left empty.
*/
(function () {
  const script = document.currentScript;
  const cards = Array.from(document.querySelectorAll('[data-podcast-art]'));
  if (!cards.length || !script) return;

  const CACHE_KEY = 'smPodArt';
  const CACHE_MS = 6 * 60 * 60 * 1000;

  function readCache() {
    try {
      const data = JSON.parse(sessionStorage.getItem(CACHE_KEY) || 'null');
      return data && Date.now() - data.at < CACHE_MS ? data.art : {};
    } catch (e) {
      return {};
    }
  }

  function writeCache(art) {
    try {
      sessionStorage.setItem(CACHE_KEY, JSON.stringify({ at: Date.now(), art }));
    } catch (e) {
      // Storage can be full or blocked; the cards still update.
    }
  }

  async function fromIndex(url) {
    try {
      const res = await fetch(url);
      return res.ok ? await res.json() : null;
    } catch (e) {
      return null;
    }
  }

  async function fromFeed(rss) {
    const art = {};
    try {
      const res = await fetch(rss);
      if (!res.ok) return art;
      const xml = new DOMParser().parseFromString(await res.text(), 'text/xml');
      xml.querySelectorAll('item').forEach((item) => {
        const date = item.querySelector('pubDate');
        const image = item.getElementsByTagName('itunes:image')[0];
        const href = image && image.getAttribute('href');
        const time = date ? Date.parse(date.textContent) : NaN;
        if (href && !Number.isNaN(time)) art[String(Math.round(time / 1000))] = href;
      });
    } catch (e) {
      // A feed that cannot be read leaves those cards on the article image.
    }
    return art;
  }

  function apply(card, src) {
    const media = card.querySelector('.podcast-card__media');
    if (!media || !src) return;
    let img = media.querySelector('img');
    if (!img) {
      img = document.createElement('img');
      img.alt = '';
      img.loading = 'lazy';
      media.prepend(img);
    }
    img.removeAttribute('srcset');
    img.removeAttribute('sizes');
    img.removeAttribute('width');
    img.removeAttribute('height');
    img.src = src;
  }

  async function run() {
    const art = readCache();
    const keys = cards.map((card) => card.dataset.podcastArt);
    let missing = keys.filter((key) => !art[key]);

    if (missing.length) {
      const index = await fromIndex(script.dataset.index);
      if (index && index.episodes) {
        missing.forEach((key) => {
          const episode = index.episodes[key];
          if (episode && episode.artwork) art[key] = episode.artwork;
        });
      }
      missing = keys.filter((key) => !art[key]);

      if (missing.length && index && index.shows) {
        const feeds = Array.from(new Set(Object.values(index.shows).map((show) => show.rss).filter(Boolean)));
        const found = await Promise.all(feeds.map(fromFeed));
        found.forEach((map) => Object.assign(art, map));
      }
      writeCache(art);
    }

    cards.forEach((card) => apply(card, art[card.dataset.podcastArt]));
  }

  run();
})();
